import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './PressKit.css';
import { Icon } from '../../types/shared/Icon';
import { Title, Image, Section } from '../../importCL';

interface IPressKitProps extends MappedComponentProperties {
    windowTitle?: string;
    icon?: Icon;
    previewImage?: string;
    description?: string;
    filePath?: string;
    fileType?: string;
    fileSize?: string;
    fileSizeUnit?: string;
    iconAltText?: string;
}

export const PressKitEditConfig = {
    emptyLabel: 'Press Kit',
    isEmpty: (props: PropsWithChildren<IPressKitProps>) => {
        return !props || !props.windowTitle;
    },
};

const PressKit = (props: PropsWithChildren<IPressKitProps>): JSX.Element => {
    return (
        <Section id='press-kit' className='PressKit'>
            <div className='PressKit__row'>
                <div className='PressKit__imageContainer'>
                    <Image loading='lazy'className='PressKit__image' src={props.previewImage} alt={props.iconAltText} href={props.filePath}/>
                </div>
                <div className='PressKit__infoContainer'>
                    <div className='PressKit__col--icon'>
                        <Image loading='lazy' className='PressKit__icon' src={props.icon?.iconPath} alt={props.iconAltText} href={props.filePath}/>
                    </div>
                    <div className='PressKit__col--text'>
                        <Title tag='h5' className='PressKit__title'>{props.windowTitle}</Title>
                        <p className='PressKit__file'>{props.fileType?.toLocaleUpperCase()}, {props.fileSize} {props.fileSizeUnit}</p>
                    </div>
                </div>
            </div>
        </Section>
    );
};

export default PressKit;
